import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import DownloadIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/Print';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import {makeStyles} from "@material-ui/core";
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';

function App(props) {
  const {src} = props;
  const renderToolbar = (PDFViewerToolbar) => (
    <PDFViewerToolbar>
        {
            (slots) => {
                const {
                    CurrentPageInput, EnterFullScreen, GoToNextPage, GoToPreviousPage, GoToFirstPage, GoToLastPage, NumberOfPages, Print, Zoom, ZoomIn, ZoomOut
                } = slots;
                return (
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            flex: '1'
                        }}
                    >
                        <Hidden mdDown><GoToFirstPage>{(props) => (<IconButton title={('Prima pagina')} onClick={props.onClick}><FirstPageIcon /></IconButton>)}</GoToFirstPage></Hidden>
                        <GoToPreviousPage>{(props) => (<IconButton title={('Pagina precedente')} onClick={props.onClick}><NavigateBeforeIcon /></IconButton>)}</GoToPreviousPage>
                        <Hidden mdDown><CurrentPageInput />&nbsp;/&nbsp;<NumberOfPages /></Hidden>
                        <GoToNextPage>{(props) => (<IconButton title={('Pagina seguente')} onClick={props.onClick}><NavigateNextIcon /></IconButton>)}</GoToNextPage>
                        <Hidden mdDown><GoToLastPage>{(props) => (<IconButton title={('Ultima pagina')} onClick={props.onClick}><LastPageIcon /></IconButton>)}</GoToLastPage></Hidden>
                        <span style={{flex: 1}}></span>
                        <ZoomOut>{(props) => (<IconButton title={('Ingrandisci')} onClick={props.onClick}><ZoomOutIcon /></IconButton>)}</ZoomOut>
                        <Hidden xsDown><Zoom /></Hidden>
                        <ZoomIn>{(props) => (<IconButton title={('Riduci')} onClick={props.onClick}><ZoomInIcon /></IconButton>)}</ZoomIn>
                        <span style={{flex: 1}}></span>
                        <EnterFullScreen>{(props) => (<IconButton title={('Schermo intero')} onClick={props.onClick}><FullscreenIcon /></IconButton>)}</EnterFullScreen>
                        <IconButton title={('Scarica documento')} component={"a"} download target="_blank" href={src} aria-label="Scarica il file"><DownloadIcon /></IconButton>
                        <Hidden mdDown><Print>{(props) => (<IconButton title={('Stampa')} onClick={props.onClick}><PrintIcon /></IconButton>)}</Print></Hidden>
                    </div>
                )
            }
        }
    </PDFViewerToolbar>
  );
  const defaultLayoutPluginInstance = defaultLayoutPlugin({ renderToolbar, sidebarTabs: defaultTabs => [defaultTabs[0]] });
  const pageNavigationPluginInstance = pageNavigationPlugin();
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
      <Viewer
        defaultScale={'PageFit'}
        // defaultScale={SpecialZoomLevel.PageWidth}
        localization={{ zoom: { actualSize: 'Automatico', pageFit: 'Adatta pagina', pageWidth: 'Adatta larghezza' }}}
        plugins={[pageNavigationPluginInstance, defaultLayoutPluginInstance]}
        fileUrl={src} />
    </Worker>
  );
}

export default App;
